enum StorageKey {
	IDENTIFIANT_EXERCICE = 'simulation.identifiantExercice',
	IDENTIFIANT_ENTITE = 'identifiantEntite',
	MIGRATION = 'migrationDone',
	MODULE_DEMANDE = 'simulation.moduleDemande',
	MODULE_NOTE_PRESENTATION = 'simulation.moduleNotePresentation',
}

export default StorageKey;
